import { useCallback, useRef, useState } from "react";
import { BASE_URL_IMAGE } from "../../../../services/ApiEndpoints";
import ToggleSwitch from "../../../../components/toggleSwitch";
// import Cropper from "react-cropper";
import Cropper from 'react-easy-crop'
import { convertBlobToBase64, getCroppedImg } from "../../../../utils/helpers";
import { toast } from "react-toastify";
const widgetOptions = {
    quickTrip: [
        "Underware",
        "Short Socks",
        "Long Socks",
        "Long Jeans",
        "Shorts",
        "T-Shirts",
        "Sweater",
        "Pigiama",
        "2in1 Hiking Pants",
        "Swimming Shorts",
    ],
    extraShoes: [
        "Flip Flop",
        "Sandals",
        "Hiking Boots",
    ],
    travelOutfit: [
        "Rain Jacket",
        "Lite Sweater",
        "T-Shirts",
        "Long Pants",
        "Socks",
        "Underware",
        "Sneakers",
        "Belt",
    ],
    toiletryKit: [
        "Tooth Brush",
        "Tooth Paste",
        "Deodorant",
        "Face Cream",
        "Shampoo",
        "Shower Gel",
        "Conditioner",
    ],
    techKit: [
        "Headphones",
        "USB C Cable",
        "Travel Adapter",
        "Power Bank",
        "Phone Charger",
    ],
    cameraKit: [
        "Go Pro",
        "Extendable Stick",
    ],
    documents: [
        "Passport",
        "Driving License",
        "Extra Credit Card",
        "Emergency Cash",
    ],
    miscellaneousItems: [
        "Water Bottle",
        "Sunglasses",
    ],

    mediumCube: [
        "T-Shirts",
        "Sport T-Shirts",
        "Pijama Outfit",
    ],
    largeCube: [
        "Sweater",
        "Sport Sweater",
        "Thermal Shirt",
        "Thermal Pants",
    ],
};

export default function WidgetManager({ onNext, onBack, preData, widgets, setWidgets }) {

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const [state, setState] = useState({
        selectedWidget: "",
        currentWidgetIndex: null,
        itemInputs: {},
        editingItem: {},
        currentFile: null,
        isModalOpen: false,
    });

    const updateState = (key, value, isNested = false) => {
        setState((prevState) => ({
            ...prevState,
            [key]: isNested ? { ...prevState[key], ...value } : value,
        }));
    };

    const handleImageUpload = async (event, index) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            updateState("currentFile", file)
            updateState("isModalOpen", true)
            updateState("currentWidgetIndex", index)
        }
    };

    const handleCrop = async () => {
        if (!croppedAreaPixels) {
            throw new Error("Crop area is not set properly.");
        }
        const imageSrc = URL.createObjectURL(state.currentFile)

        const croppedImageFile = await getCroppedImg(imageSrc, croppedAreaPixels);

        // Clean up memory
        URL.revokeObjectURL(imageSrc);

        if (!croppedImageFile) {
            throw new Error("Failed to process cropped image.");
        }

        const croppedImage = await convertBlobToBase64(croppedImageFile);; // Base64 String

        if (!croppedImage) {
            console.error("Failed to generate cropped image!");
            return;
        }

        if (state.currentWidgetIndex === null || state.currentWidgetIndex < 0) {
            console.error("Invalid widget index!");
            return;
        }

        // Ensure that prevWidgets is an array before updating
        setWidgets((prevWidgets) => {
            if (!Array.isArray(prevWidgets)) {
                console.error("Widgets state is not an array!");
                return prevWidgets; // Return previous state to prevent errors
            }

            // Create a new array (copy of prevWidgets)
            const updatedWidgets = [...prevWidgets];

            if (updatedWidgets[state.currentWidgetIndex]) {
                // Create a new object instead of modifying the old one
                updatedWidgets[state.currentWidgetIndex] = {
                    ...updatedWidgets[state.currentWidgetIndex],
                    image: croppedImage,
                };
            } else {
                console.error(`Widget at index ${state.currentWidgetIndex} not found!`);
            }

            return updatedWidgets;
        });

        // Reset states after cropping
        updateState("currentWidgetIndex", null);
        updateState("currentFile", null);
        updateState("isModalOpen", false);
    };



    // const handleAddWidget = () => {
    //     if (state.selectedWidget && !widgets.some((w) => w.type === state.selectedWidget)) {
    //         setWidgets((prev) => [
    //             ...prev,
    //             { type: state.selectedWidget, name: "My Quick Trip Bag", url: "", image: "", items: [] },
    //         ]);
    //     }
    //     updateState("selectedWidget", "")
    // };

    const handleAddWidget = () => {
        if (!state.selectedWidget) return; // Prevent adding empty selection

        if (widgets.some((w) => w.type === state.selectedWidget)) {
            toast.error("Already selected"); // Show error if the widget is already added
            return;
        }

        const selectedType = state.selectedWidget;

        // Find matching preData entry
        const prefilledData = preData.find((item) => item.type === selectedType);

        // Construct new widget with prefilled data
        const newWidget = {
            type: selectedType,
            name: prefilledData ? prefilledData.name : selectedType.replace(/([A-Z])/g, " $1").trim(),
            image: prefilledData ? prefilledData.image : "",
            url: prefilledData ? prefilledData.url : "",
            defaultType: prefilledData ? prefilledData.defaultType : "regular",
            items: []
        };

        setWidgets((prev) => [...prev, newWidget]);

        updateState("selectedWidget", ""); // Reset selection after adding
    };

    const handleWidgetDetailsChange = (index, field, value) => {
        setWidgets((prevWidgets) =>
            prevWidgets.map((widget, idx) =>
                idx === index ? { ...widget, [field]: value } : widget
            )
        );
    };

    const handleAddItem = (widgetType) => {
        const { name = "", quantity = 1, notes = "", url = "", isDiscover = false } = state.itemInputs[widgetType] || {};
        if (name.trim()) {
            setWidgets((prev) =>
                prev.map((w) =>
                    w.type === widgetType
                        ? { ...w, items: [...w.items, { name, quantity, notes, url, isDiscover }] }
                        : w
                )
            );
            updateState("itemInputs", { ...state.itemInputs, [widgetType]: {} });
            // setItemInputs((prev) => ({ ...prev, [widgetType]: {} }));
        }
    };

    const handleEditItem = (widgetType, index) => {
        // setEditingItem({ widgetType, index });
        // setItemInputs((prev) => ({
        //     ...prev,
        //     [widgetType]: { ...widgets.find((w) => w.type === widgetType).items[index] },
        // }));
        const widget = widgets.find((w) => w.type === widgetType);
        if (!widget) {
            console.error(`Widget with type "${widgetType}" not found.`);
            return;
        }
        updateState("editingItem", { widgetType, index });

        updateState("itemInputs", {
            ...state.itemInputs,
            [widgetType]: { ...widget.items[index] },
        });
    };

    const handleSaveEdit = (widgetType, index) => {
        const updatedItem = state.itemInputs[widgetType];
        setWidgets((prev) =>
            prev.map((w) =>
                w.type === widgetType
                    ? {
                        ...w,
                        items: w.items.map((item, idx) => (idx === index ? updatedItem : item)),
                    }
                    : w
            )
        );
        updateState("editingItem", {});
        updateState("itemInputs", { ...state.itemInputs, [widgetType]: {} });
    };

    const handleRemoveItem = (widgetType, index) => {
        setWidgets((prev) =>
            prev.map((w) =>
                w.type === widgetType
                    ? { ...w, items: w.items.filter((_, idx) => idx !== index) }
                    : w
            )
        );
    };

    const handleRemoveWidget = (widgetType) => {
        if (widgetType !== "quickTrip") {
            setWidgets((prev) => prev.filter((w) => w.type !== widgetType));
        }
    };
    const validate = () => {
        // if (input.trim() === '') {
        //     setError('This field is required.');
        //     return false;
        // }
        // setError('');
        return true;
    };
    const handleSubmit = () => {
        onNext({ widgets }, validate())
    }

    return (
        <div className='max-w-[1000px] !mx-auto space-y-6 bg-white p-8 mt-10' >
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-roboto-mono text-dark font-bold">Add Widgets</h2>
                <div className="flex items-center gap-2">
                    <select
                        className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-72"
                        value={state.selectedWidget}
                        onChange={(e) => updateState("selectedWidget", e.target.value)}
                    >
                        <option value="">Select Widget to Add</option>
                        {preData?.map((widget) => (
                            <option key={widget?._id} value={widget?.type}>
                                {widget?.type?.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                            </option>
                        ))}
                    </select>

                    <button
                        className="bg-bgprimary text-dark px-4 py-2 rounded-md font-bold font-roboto-mono text-[14px]"
                        onClick={handleAddWidget}
                    >
                        Add Widget
                    </button>
                </div>
            </div>


            {widgets.map((widget, index) => (
                <div key={widget.name} className="p-4  bg-[#F9F9F9] ">
                    <div className="bg-white p-4 relative">
                        <h3 className="text-2xl font-roboto-mono text-dark font-bold capitalize mb-2">{widget.type.replace(/([A-Z])/g, " $1")}</h3>

                        {widget.type !== "quickTrip" && (
                            <button
                                className="absolute -top-2 -right-2 bg-red-500 p-1 rounded-full"
                                onClick={() => handleRemoveWidget(widget.type)}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.90591 5.17767L5.66675 15.8135C5.74729 16.3004 5.99807 16.7429 6.37442 17.0622C6.75076 17.3814 7.22822 17.5567 7.72175 17.5568H10.5117M16.0934 5.17767L14.3334 15.8135C14.2529 16.3004 14.0021 16.7429 13.6257 17.0622C13.2494 17.3814 12.7719 17.5567 12.2784 17.5568H9.48841M8.35175 9.2635V13.471M11.6484 9.2635V13.471M2.29175 5.17767H17.7084M12.3142 5.17767V3.69434C12.3142 3.36282 12.1826 3.04487 11.9481 2.81045C11.7137 2.57603 11.3958 2.44434 11.0642 2.44434H8.93591C8.60439 2.44434 8.28645 2.57603 8.05203 2.81045C7.81761 3.04487 7.68591 3.36282 7.68591 3.69434V5.17767H12.3142Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </button>
                        )}

                        <div className="grid md:grid-cols-7 grid-cols-1 gap-4 mb-5">
                            {/* <input
                                type="text"
                                className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                placeholder="Widget Name"
                                value={widget.name}
                                onChange={(e) => handleWidgetDetailsChange(index, "name", e.target.value)}
                            /> */}
                            <div className="col-span-2 self-center">
                                <label htmlFor="">Default Url</label>
                                <input
                                    type="url"
                                    className="border h-fit border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                    placeholder="Enter a valid URL"
                                    value={widget.url}
                                    onChange={(e) => handleWidgetDetailsChange(index, "url", e.target.value)}
                                    pattern="https?://.*"
                                    title="Please enter a valid URL (starting with http:// or https://)"
                                    readOnly={widget.defaultType == "regular" ? true : false}
                                />
                            </div>
                            <div className="col-span-1 self-center">
                                <label htmlFor="">Default Type</label>
                                <ToggleSwitch
                                    checked={widget.defaultType === "pro"}
                                    onChange={(checked) => handleWidgetDetailsChange(index, "defaultType", checked ? "pro" : "regular")}
                                />
                            </div>
                            <div className="col-span-2 self-center">
                                <label htmlFor="">Default Image</label>
                                <input
                                    type="file"
                                    className="border h-fit border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                    onChange={(e) => handleImageUpload(e, index)}
                                    accept="image/*"
                                    readOnly={widget.defaultType === "regular"}
                                    disabled={widget.defaultType === "regular"}
                                />
                            </div>
                            <div className="col-span-2 self-center">
                                {widget.image && (
                                    <img
                                        src={widget.image.startsWith("data:image") ? widget.image : `${BASE_URL_IMAGE}${widget.image}`}
                                        alt="image"
                                        className="w-40 h-40 object-cover border rounded-md"
                                    />
                                )}
                            </div>






                        </div>
                        <div className="flex justify-end mb-3">
                            {state.editingItem?.widgetType === widget.type ? (
                                <button
                                    className="bg-bgprimary text-dark px-4 py-2 rounded-md font-bold font-roboto-mono text-[14px]"
                                    onClick={() => handleSaveEdit(widget.type, state.editingItem.index)}
                                >
                                    Save
                                </button>
                            ) : (
                                <button
                                    className="bg-bgprimary text-dark px-4 py-2 rounded-md font-bold font-roboto-mono text-[14px] w-auto ml-auto"
                                    onClick={() => handleAddItem(widget.type)}
                                >
                                    Add Item
                                </button>
                            )}
                        </div>

                        <div className="grid md:grid-cols-4 grid-cols-1 gap-4 mb-2">
                            {/* <select
                                className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                value={itemInputs[widget.type]?.name || ""}
                                onChange={(e) => setItemInputs((prev) => ({ ...prev, [widget.type]: { ...prev[widget.type], name: e.target.value } }))}
                            >
                                <option value="">Select Item</option>
                                {widgetOptions[widget.type]?.map((item) => (
                                    <option key={item} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select> */}
                            <input
                                type="text"
                                className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                placeholder="Add Items"
                                value={state.itemInputs[widget.type]?.name || ""}
                                onChange={(e) =>
                                    updateState("itemInputs", {
                                        ...state.itemInputs,
                                        [widget.type]: {
                                            ...state.itemInputs[widget.type],
                                            name: e.target.value,
                                        },
                                    })
                                }
                            />

                            <input
                                type="number"
                                className="border border-bgprimary text-[#1F2937AB] font-medium text-[16px] font-quicksand rounded-md p-2 w-full"
                                min="1"
                                placeholder="Qty"
                                value={state.itemInputs[widget.type]?.quantity || ""}
                                onChange={(e) =>
                                    updateState("itemInputs", {
                                        ...state.itemInputs,
                                        [widget.type]: {
                                            ...state.itemInputs[widget.type],
                                            quantity: Math.max(1, Number(e.target.value.replace(/\D/g, ""))), // Remove non-numeric values
                                        },
                                    })
                                }
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                        e.preventDefault(); // Prevent "e", "E", "+", and "-" from being entered
                                    }
                                }}
                            />

                            <input
                                type="text"
                                className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                placeholder="Notes (optional)"
                                value={state.itemInputs[widget.type]?.notes || ""}
                                onChange={(e) =>
                                    updateState("itemInputs", {
                                        ...state.itemInputs,
                                        [widget.type]: {
                                            ...state.itemInputs[widget.type],
                                            notes: e.target.value.trimStart(), // Prevent leading spaces
                                        },
                                    })
                                }
                            />
                            <div className="flex items-center gap-1">
                                <ToggleSwitch checked={state.itemInputs[widget.type]?.isDiscover || false}
                                    onChange={(key) =>
                                        updateState("itemInputs", {
                                            ...state.itemInputs,
                                            [widget.type]: {
                                                ...state.itemInputs[widget.type],
                                                isDiscover: key, // Update isDiscover while preserving other properties
                                            },
                                        })
                                    }
                                />
                                {state.itemInputs[widget.type]?.isDiscover == true && (
                                    <input
                                        type="text"
                                        className="border border-bgprimary text-[#1F2937AB] font-medium  text-[16px] font-quicksand rounded-md p-2 w-full"
                                        placeholder="URL"
                                        value={state.itemInputs[widget.type]?.url || ""}
                                        onChange={(e) =>
                                            updateState("itemInputs", {
                                                ...state.itemInputs,
                                                [widget.type]: {
                                                    ...state.itemInputs[widget.type],
                                                    url: e.target.value, // Update 'url' without overriding other fields
                                                },
                                            })
                                        }
                                    />
                                )}

                            </div>


                        </div>
                        {widget.items.length > 0 && (
                            <div className="text-sm bg-[#F9F9F9] grid md:grid-cols-3 grid-cols-1 gap-4 p-4">
                                {widget.items.map((entry, idx) => (
                                    <div
                                        key={idx}
                                        className="flex justify-between text-dark items-center bg-white rounded-[10px] shadow-sm h-16"
                                    >
                                        <span className="p-2" >
                                            {entry.name} (x{entry.quantity}) <br />
                                            {entry.notes && <div className="text-gray-500 text-xs line-clamp-1">  {entry.notes.slice(`0`, `30`)}</div>}
                                        </span>
                                        <div className="flex flex-col h-full">
                                            <button
                                                className="bg-bgprimary text-sm h-1/2 p-2 rounded-tr-[10px]"
                                                onClick={() => handleRemoveItem(widget.type, idx)}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.90591 5.17767L5.66675 15.8135C5.74729 16.3004 5.99807 16.7429 6.37442 17.0622C6.75076 17.3814 7.22822 17.5567 7.72175 17.5568H10.5117M16.0934 5.17767L14.3334 15.8135C14.2529 16.3004 14.0021 16.7429 13.6257 17.0622C13.2494 17.3814 12.7719 17.5567 12.2784 17.5568H9.48841M8.35175 9.2635V13.471M11.6484 9.2635V13.471M2.29175 5.17767H17.7084M12.3142 5.17767V3.69434C12.3142 3.36282 12.1826 3.04487 11.9481 2.81045C11.7137 2.57603 11.3958 2.44434 11.0642 2.44434H8.93591C8.60439 2.44434 8.28645 2.57603 8.05203 2.81045C7.81761 3.04487 7.68591 3.36282 7.68591 3.69434V5.17767H12.3142Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </button>
                                            <button
                                                className="bg-aths text-sm h-1/2 p-2 rounded-br-[10px]"
                                                onClick={() => handleEditItem(widget.type, idx)}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.83325 5.8335H4.99992C4.55789 5.8335 4.13397 6.00909 3.82141 6.32165C3.50885 6.63421 3.33325 7.05814 3.33325 7.50016V15.0002C3.33325 15.4422 3.50885 15.8661 3.82141 16.1787C4.13397 16.4912 4.55789 16.6668 4.99992 16.6668H12.4999C12.9419 16.6668 13.3659 16.4912 13.6784 16.1787C13.991 15.8661 14.1666 15.4422 14.1666 15.0002V14.1668" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M13.3333 4.16676L15.8333 6.66676M16.9875 5.48759C17.3157 5.15938 17.5001 4.71424 17.5001 4.25009C17.5001 3.78594 17.3157 3.34079 16.9875 3.01259C16.6593 2.68438 16.2142 2.5 15.75 2.5C15.2858 2.5 14.8407 2.68438 14.5125 3.01259L7.5 10.0001V12.5001H10L16.9875 5.48759Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>

                                            </button>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>

                </div>
            ))}

            {/* <pre className="mt-6 bg-gray-100 p-4 rounded text-sm overflow-auto">
                {JSON.stringify(widgets, null, 2)}
            </pre> */}

            <div className="flex justify-end gap-4 mt-4">

                <button onClick={onBack} className="px-4 py-2 bg-aths text-dark font-roboto-mono font-bold rounded">Back</button>

                <button onClick={handleSubmit} className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded">Next</button>

            </div>

            {state.isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[350px] h-[600px] relative">
                        <h2 className="text-lg font-bold mb-2">Crop Your Image</h2>
                        <div className="crop-container h-[200px] w-full">
                            <Cropper
                                image={URL.createObjectURL(state.currentFile)}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 3}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                style={{ height: "200px", width: "100%" }}
                            />
                        </div>
                        <div className="controls">
                            <input
                                type="range"
                                value={zoom}
                                min={0.5}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                onChange={(e) => {
                                    setZoom(e.target.value)
                                }}
                                className="zoom-range"
                            />
                        </div>

                        <div className="flex justify-end space-x-2 mt-4 absolute bottom-4 left-[35%] translate-x-[-50%] w-full">
                            <button className="px-4 py-2 bg-gray-400 text-dark rounded border border-bgprimary" onClick={() => updateState("isModalOpen", false)}>
                                Cancel
                            </button>
                            <button className="px-4 py-2 bg-bgprimary text-dark font-roboto-mono font-bold rounded" onClick={handleCrop}>
                                Crop & Save
                            </button>
                        </div>


                    </div>
                </div>
            )}


        </div>
    );
}
